<template>
  <el-form
    ref="formRef"
    :model="formData"
    :rules="rules"
    label-width="120px"
    label-position="top"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('message.template.name')" prop="name">
          <el-input v-model="formData.name" />
        </el-form-item>
      </el-col>
    </el-row>
    
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('message.template.company')" prop="company_id">
          <el-tree-select
            v-model="formData.company_id"
            :data="companyTreeData"
            :props="treeProps"
            :placeholder="$t('message.template.selectCompany')"
            check-strictly
            clearable
            filterable
            style="width: 100%"
            :loading="companyLoading"
            @visible-change="handleTreeVisibleChange"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="button-row">
      <el-col :span="12">
        <el-button-group class="getType-switch">
          <el-button
            :class="{ active: formData.get_type === 1 }"
            @click="changeGetType(1)"
            size="small"
            v-if="false"
          >
            {{ $t('message.template.getTypeA') }}
          </el-button>
          <el-button
            :class="{ active: formData.get_type === 2 }"
            @click="changeGetType(2)"
            size="small"
          >
            {{ $t('message.template.getTypeB') }}
          </el-button>
        </el-button-group>
      </el-col>     
    </el-row>
     
    <!-- 改进的从机Tab管理部分 -->
    <el-tabs 
      v-if="tabsReady"  
      v-model="activeTab" 
      type="card" 
      editable 
      @tab-remove="removeTab"
      @edit="addTab" 
      class="slave-tabs"
      @tab-change="handleTabChange"
    > 
      <!-- 从机Tab页 -->
      <el-tab-pane
        v-for="tab in slaveTabs"
        :key="tab.name"
        :label="renderTabLabel(tab)"
        :name="tab.name"
        :closable="slaveTabs.length > 1"         
      >
        <!-- 从机配置内容 -->
        <div class="slave-config">
          <!-- 从机基本信息 -->
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item :label="$t('message.slave.tabName')" prop="label">
                <el-input v-model="tab.label" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('message.slave.protocol')" prop="protocol">
                <el-select 
                  v-model="tab.protocol" 
                  :placeholder="$t('message.slave.protocol')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in protocolOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>           
          </el-row>

          <!-- 变量操作按钮和查询表单 -->
          <el-row :gutter="20" class="action-buttons">
            <el-col :span="12">
              <div class="button-group">
                <el-button 
                  type="primary" 
                  size="small"
                  @click="addVariable(tab.name)"
                  :icon="Plus"
                >
                  {{ $t('message.slave.addVariable') }}
                </el-button>

                <el-button 
                  type="primary" 
                  size="small"
                  @click="importVariables(tab.name)"
                  :icon="Upload"
                >
                  {{ $t('message.slave.importVariables') }}
                </el-button>

                <!-- 新增的导入更新按钮 -->
                <el-button 
                  type="warning" 
                  size="small"
                  @click="importUpdateVariables(tab.name)"
                  :icon="Upload"
                >
                  {{ $t('message.slave.importUpdateVariables') || '导入更新变量' }}
                </el-button>

                <el-button 
                  type="primary" 
                  size="small"
                  :loading="exportLoading"
                  @click="handleExport(tab.name)"
                  :icon="Download"
                >
                  {{ $t('message.slave.exportVariables') }}
                </el-button>

                <el-button 
                  type="danger" 
                  size="small"
                  @click="batchDeleteVariables(tab.name)"
                  :disabled="!tab.variables.length"
                  :icon="Delete"
                >
                  {{ $t('message.slave.batchDelete') }}
                </el-button>
              </div>
            </el-col>
            
            <el-col :span="12">
              <div class="search-group">
                <el-input
                  v-model="queryParams.name"
                  :placeholder="$t('message.slave.varName')"
                  size="small"
                  clearable
                  style="width: 200px; margin-right: 10px;"
                />
                <el-input
                  v-model="queryParams.display_name"
                  :placeholder="$t('message.slave.variableInputDisplayName')"
                  size="small"
                  clearable
                  style="width: 200px; margin-right: 10px;"
                />
                
                <el-button 
                  type="primary" 
                  size="small"
                  @click="searchVariables" 
                  :icon="Search"
                >
                  {{ $t('message.slave.queryVariable') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
      
          <!-- 变量表格 -->        
          <el-table 
            :data="tab.variables"             
            border 
            style="width: 100%"     
            :max-height="300"     
            @selection-change="handleSelectionChange(tab.name, $event)"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column   
              prop="name" 
              :label="$t('message.slave.varName')" 
              min-width="120"
              sortable
            />
            
            <el-table-column 
              prop="display_name" 
              :label="$t('message.slave.display_name')" 
              min-width="120"
              sortable
            />
            <el-table-column 
              prop="name_group" 
              :label="$t('message.slave.name_group')" 
              min-width="120"
              sortable
            />
            <el-table-column 
              prop="register" 
              :label="$t('message.slave.register')" 
              min-width="120"
              sortable
            />
             
            <el-table-column 
              prop="data_type_name" 
              :label="$t('message.slave.valueType')" 
              min-width="120"
              sortable
            />

            <el-table-column 
              prop="rw_type_name" 
              :label="$t('message.slave.rwType')"
              min-width="120"
              sortable
            />

            <el-table-column 
              prop="value" 
              :label="$t('message.slave.value')"
              min-width="120"
              sortable
            >
              <template #default="{ row }">
                <span v-if="row.value !== null && row.value !== undefined">
                  {{ formatValueNoScientific(row.value,1,row.address_decimal) }}
                </span>
                <span v-else class="empty-value">--</span>
              </template>
            </el-table-column>

            <el-table-column 
              :label="$t('message.slave.actions')" 
              width="120"
              fixed="right"
            >
              <template #default="{ $index }">
                <el-button
                  size="small"
                  type="primary"
                  @click="editVariable(tab.name, $index)"
                  :icon="Edit"
                  circle
                />
                <el-button
                  size="small"
                  type="danger"
                  @click="deleteVariable(tab.name, $index)"
                  :icon="Delete"
                  circle
                />
              </template>           
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-pagination
        v-model:current-page="queryParams.pageNum"
        v-model:page-size="queryParams.pageSize"
        :page-sizes="[5,10, 20, 30,100,500,1000,2000]"
        :total="queryParams.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-top: 15px"
      />
    </el-tabs>
    
    <!-- 变量编辑弹窗 -->
    <el-dialog
      v-model="variableDialogVisible"
      :title="variableDialogTitle"
      width="75%"    
      :close-on-click-modal="false"
    >
      <el-form
        ref="variableFormRef"
        :model="currentVariable"
        label-width="130px"
        label-position="right"
        :rules="rules"
      >
        <!-- 第一行：基本信息 -->
        <el-divider content-position="left">{{ $t('message.slave.basicInformation') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.varName')" prop="variablename">
              <el-input 
                v-model="currentVariable.name" 
                clearable
                :placeholder="$t('message.slave.variableInputName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.display_name')" prop="variableDisplayname">
              <el-input 
                v-model="currentVariable.display_name" 
                clearable
                :placeholder="$t('message.slave.variableInputDisplayName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.unit')" prop="unit">
              <el-input v-model="currentVariable.unit" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：描述信息 -->  
        <el-divider content-position="left">{{ $t('message.slave.descriptionInformation') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('message.slave.description')" prop="variableDescription">
              <el-input 
                v-model="currentVariable.description" 
                clearable
                :placeholder="$t('message.slave.InputDescription')"
                type="textarea"
                :rows="2"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('message.slave.name_group')" prop="nameGroup">
              <el-input 
                v-model="currentVariable.name_group" 
                clearable
                :placeholder="$t('message.slave.InputNameGroup')"
              />
            </el-form-item>
          </el-col>
        </el-row>
     
        <!-- 第三行：寄存器配置 -->
        <el-divider content-position="left">{{ $t('message.slave.registerConfig') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item :label="$t('message.slave.registerType')" prop="register_type">
              <el-select v-model="currentVariable.register_type" style="width:100%">
                <el-option
                  v-for="item in registerTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('message.slave.addressOne')" prop="address_one">
              <el-input-number 
                v-model="currentVariable.address_one" 
                :min="0" 
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('message.slave.addressDecimal')" prop="address_decimal">
              <el-input-number 
                v-model="currentVariable.address_decimal" 
                :min="0" 
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行：数据类型配置 -->
        <el-divider content-position="left">{{ $t('message.slave.dataTypeConfig') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.VariabledataType')" prop="data_type_id">
              <el-select v-model="currentVariable.data_type_id" style="width:100%">
                <el-option
                  v-for="item in valueTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.rwType')" prop="rw_type_id">
              <el-select v-model="currentVariable.rw_type_id" style="width:100%">
                <el-option
                  v-for="item in rwTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第五行：数值配置 --> 
        <el-divider content-position="left">{{ $t('message.slave.dataValueConfig') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.value')" prop="value">
              <el-input-number 
                v-model="currentVariable.value" 
                :min="0" 
                style="width:100%"
              />          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.mult')" prop="mult">
              <el-input-number 
                v-model="currentVariable.mult"             
                :step="0.01"              
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.minimum')" prop="minimum">
              <el-input-number 
                v-model="currentVariable.minimum"             
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.slave.maximum')" prop="maximum">
              <el-input-number 
                v-model="currentVariable.maximum"             
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="variableDialogVisible = false">
            {{ $t('message.common.cancel') }}
          </el-button>
          <el-button type="primary" @click="saveVariable">
            {{ $t('message.common.confirm') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入变量弹框（新增） -->
    <el-dialog
      v-model="importDialogVisible"
      :title="t('message.slave.importVariables')"
      width="40%"
      :close-on-click-modal="false"
    >
      <div class="import-dialog-content">
        <el-upload
          ref="importFileDialog"
          class="upload-demo"
          drag
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleFileChange"
          :limit="1"
          accept=".xlsx,.xls"
          :key="uploadKey" 
          :disabled="importLoading"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            <template v-if="importLoading">
              {{ t('message.slave.importing') }}...
            </template>
            <template v-else>
              {{ t('message.slave.dragFileHere') }}<em>{{ t('message.slave.clickToUpload') }}</em>
            </template>
          </div>

          <template #tip>
            <div class="el-upload__tip">
              {{ t('message.slave.supportedFileTypes') }}: xlsx, xls
              <div v-if="selectedFile" class="selected-file">
                {{ t('message.slave.selectedFile') }}: {{ selectedFile.name }}
              </div>
            </div>
          </template>
        </el-upload>
      </div>
      <template #footer>
        <el-button @click="closeImportDialog">
          {{ t('message.common.cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmImport" :loading="importLoading">
          {{ t('message.common.confirm') }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 导入更新变量弹框（新增） -->
    <el-dialog
      v-model="importUpdateDialogVisible"
      :title="t('message.slave.importUpdateVariables') || '导入更新变量'"
      width="40%"
      :close-on-click-modal="false"
    >
      <div class="import-dialog-content">
        <el-upload
          ref="importUpdateFileDialog"
          class="upload-demo"
          drag
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleImportUpdateFileChange"
          :limit="1"
          accept=".xlsx,.xls"
          :key="importUpdateUploadKey" 
          :disabled="importUpdateLoading"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            <template v-if="importUpdateLoading">
              {{ t('message.slave.importing') }}...
            </template>
            <template v-else>
              {{ t('message.slave.dragFileHere') }}<em>{{ t('message.slave.clickToUpload') }}</em>
            </template>
          </div>

          <template #tip>
            <div class="el-upload__tip">
              {{ t('message.slave.supportedFileTypes') }}: xlsx, xls
              <div v-if="selectedUpdateFile" class="selected-file">
                {{ t('message.slave.selectedFile') }}: {{ selectedUpdateFile.name }}
              </div>
              <div class="import-update-tip" style="margin-top: 8px;">
                <el-alert
                  :title="t('message.slave.importUpdateTip') || '此操作将根据文件中的变量名称更新现有变量的配置信息'"
                  type="warning"
                  :closable="false"
                  show-icon
                  size="small"
                />
              </div>
            </div>
          </template>
        </el-upload>
      </div>
      <template #footer>
        <el-button @click="closeImportUpdateDialog">
          {{ t('message.common.cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmImportUpdate" :loading="importUpdateLoading">
          {{ t('message.common.confirm') }}
        </el-button>
      </template>
    </el-dialog>
  </el-form>
</template>

<script setup>
import { ref, reactive, nextTick, watch, onMounted, defineProps, defineExpose } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Delete, Upload, Download, Search, Edit } from '@element-plus/icons-vue'
import { getCompanyTree } from '@/api/CompanyManager'
import { useI18n } from 'vue-i18n'
import {
  fetchVariableOptions,
  createTemplate,
  updateTemplate,
  getVariablesByTemplate,
  createSlave,
  updateSlave,
  deleteSlave,
  createVariable,
  updateVariable,
  deleteVariableById,
  importVariablesByFile,
  importUpdateVariablesByFile,
  exportVariablesByFile
} from '@/api/TemplateManagement'
import { formatValueNoScientific, smartFixFloatPrecision } from "@/api/DeviceManagement";

const uploadKey = ref(0)
const { t } = useI18n()

const props = defineProps({
  templateData: {
    type: Object,
    default: () => ({})
  },
  slaveTabsData: {
    type: Array,
    default: () => []
  }
});

// 存储选项数据
const variableOptions = ref({
  dataTypes: [],
  rwTypes: [],
  storageTypes: [],
  varTypes: [],
  protocolTypes: [],
})

// 查询条件
const queryParams = reactive({
  template_id: null,
  slave_id: null,
  name: '',
  display_name: '',
  pageNum: 1,
  pageSize: 5,
  total: 0
})

// 表单相关
const formRef = ref()
const formData = ref({
  id: 0,
  name: '',
  company_id: null,
  company_name: '',
  get_type: 2,
  get_type_name: '',
  sub_user: 0,
  state_type: 1,
  var_total: 0,
  device_total: 0
})

// 使用 props.slaveTabsData 代替原来的 slaveTabs
const slaveTabs = ref(JSON.parse(JSON.stringify(props.slaveTabsData)));

const companyTreeData = ref([])
const companyLoading = ref(false)
const companyLoaded = ref(false)

// 在 script 中添加
const tabsReady = ref(false);

// 从机Tab管理
const activeTab = ref(props.slaveTabsData[0]?.name || 'slave1');

// 变量编辑弹窗相关
const variableDialogVisible = ref(false)
const variableDialogTitle = ref('')
const variableFormRef = ref()
const currentVariable = ref({
  id: 0,
  name: '',
  display_name: '',
  description: '',
  name_group: '',
  register_type: 3,
  address_one: 0,
  address_two: 0,
  address_three: 0,
  address_four: 0,
  address_five: 0,
  address_six: 0,
  address_decimal: 0,
  register_num: 1,
  data_type_id: 1,
  rw_type_id: 1,
  timed_storage_frequency: 0,
  change_storage_val: 0,
  storage_type_id: 1,
  var_type_id: 1,
  interval: 0,
  var_flag: '',
  unit: '',
  mult: 1,
  minimum: 0,
  maximum: 0,
  value: 0,
  slave_id: 0,
  template_id: 0,
  company_id: 0
})

// 寄存器类型选项
const registerTypeOptions = [
  { value: 0, label: '0 Coils Status' },
  { value: 1, label: '1 Discrete Inputs' },
  { value: 3, label: '3 Input Registers' },
  { value: 4, label: '4 Holding Registers' }
]

// 选项数据
const varTypeOptions = ref([]);
const rwTypeOptions = ref([]);
const storageModeOptions = ref([]);
const protocolOptions = ref([]);
const valueTypeOptions = ref([]);

// 导入相关
const importDialogVisible = ref(false)
const importFileDialog = ref(null)
const selectedFile = ref(null)
const currentTabName = ref('')
const importLoading = ref(false)

// 导入更新相关（新增）
const importUpdateDialogVisible = ref(false)
const importUpdateFileDialog = ref(null)
const importUpdateLoading = ref(false)
const currentUpdateTabName = ref('')
const selectedUpdateFile = ref(null)
const importUpdateUploadKey = ref(0)

// 导出相关
const exportLoading = ref(false)

// 树形选择器属性
const treeProps = {
  value: 'id',
  label: 'name',
  children: 'children'
}

const queryCompanyTreeParams = reactive({
  companyId: null
})

// 表单验证规则
const rules = {
  name: [{ required: true, message: t('message.template.nameRequired'), trigger: 'blur' }],
  company_id: [{ required: true, message: t('message.template.companyRequired'), trigger: 'change' }],
  get_type: [{ required: true, message: t('message.template.getTypeRequired'), trigger: 'change' }],
  variablename: [{ required: true, message: t('message.slave.variableInputName'), trigger: 'blur' }],
  variableDisplayname: [{ required: true, message: t('message.slave.variableInputDisplayName'), trigger: 'blur' }],
  variableDescription: [{ required: true, message: t('message.slave.InputDescription'), trigger: 'blur' }],
  nameGroup: [{ required: true, message: t('message.slave.InputNameGroup'), trigger: 'blur' }]
}

// ========== 初始化方法 ==========
const loadOptions = () => {
  storageModeOptions.value = [
    { value: 1, label: t('message.slave.storageModeOptionA') },
    { value: 2, label: t('message.slave.storageModeOptionB') }
  ];
  
  rwTypeOptions.value = [
    { value: 1, label: t('message.slave.rwTypeRW') },
    { value: 2, label: t('message.slave.rwTypeR') },
    { value: 3, label: t('message.slave.rwTypeW') }
  ];

  varTypeOptions.value = [
    { value: 1, label: t('message.slave.variableTypeA') },
    { value: 2, label: t('message.slave.variableTypeB') },
    { value: 3, label: t('message.slave.variableTypeC') }
  ];

  protocolOptions.value = [
    { value: 1, label: 'Modbus RTU' },
    { value: 2, label: 'Modbus TCP' },
    { value: 3, label: 'BacNet' }
  ];

  valueTypeOptions.value = [
    { value: 1, label: 'ushort' },
    { value: 2, label: 'short' },
    { value: 3, label: '16bit-BCD' },
    { value: 4, label: 'long-ABCD' },
    { value: 5, label: 'long-CDAB' },
    { value: 6, label: 'long-DCBA' },
    { value: 7, label: 'ulong-ABCD' },
    { value: 8, label: 'ulong-CDAB' },
    { value: 9, label: 'ulong-DCBA' },
    { value: 10, label: 'float-ABCD' },
    { value: 11, label: 'float-CDAB' },
    { value: 12, label: 'float-DCBA' },
    { value: 13, label: '32bit-BCD' },
    { value: 14, label: 'double' },
    { value: 15, label: 'double-CDAB' },
    { value: 16, label: 'ulong-unixtime' },
    { value: 17, label: '30bytes-location' },
    { value: 18, label: 'bit' },
    { value: 19, label: 'String' },
  ];

  // 将所有选项数据赋值给 variableOptions
  variableOptions.value.dataTypes = valueTypeOptions;
  variableOptions.value.rwTypes = rwTypeOptions.value;
  variableOptions.value.storageTypes = storageModeOptions.value;
  variableOptions.value.varTypes = varTypeOptions.value;
  variableOptions.value.protocolTypes = protocolOptions;
};

const initializeSlaveTabs = async () => {
  if (props.slaveTabsData?.length > 0) {
    slaveTabs.value = JSON.parse(JSON.stringify(props.slaveTabsData));
    activeTab.value = slaveTabs.value[0]?.name || t('message.slave.tabName');
  } else {
    slaveTabs.value = [{
      id: 0,
      name: t('message.slave.tabName'),
      label: t('message.slave.tabName') + ' 1',
      protocol: 1,
      variables: [],
      selectedVariables: []
    }];
    activeTab.value = t('message.slave.tabName');
    
    queryParams.template_id = 0;
    queryParams.slave_id = 0;
    queryParams.name = '';
    queryParams.pageNum = 1;
    queryParams.pageSize = 5;
    queryParams.total = 0;
  }
  await nextTick();
};

const resetCurrentVariable = (slaveId) => {
  currentVariable.value = {
    id: 0,
    name: '',
    display_name: '',
    description: '',
    name_group: '',
    register_type: 0,
    address_one: 0,
    address_two: 0,
    address_three: 0,
    address_four: 0,
    address_five: 0,
    address_six: 0,
    address_decimal: 0,
    register_num: 1,
    data_type_id: 1,
    rw_type_id: 1,
    timed_storage_frequency: 0,
    change_storage_val: 0,
    storage_type_id: 1,
    var_type_id: 1,
    interval: 0,
    var_flag: '',
    unit: '',
    mult: 1,
    minimum: 0,
    maximum: 0,
    value: 0,
    slave_id: slaveId,
    template_id: formData.value.id,
    company_id: formData.value.company_id
  }
}

// ========== 模板相关方法 ==========
const createTemplateSumit = async () => {
  try {
    try {
      await formRef.value.validate();
    } catch (error) {
      ElMessage.error(error.message || t('message.template.validate'))
      return { success: false, message: t('message.template.validate') };
    }

    const submitData = {
      name: formData.value.name,
      company_id: formData.value.company_id,
      get_type: formData.value.get_type,
      sub_user: formData.value.sub_user,
      state_type: formData.value.state_type,
      created_at: new Date().toISOString()
    }

    if (formData.value.id) {
      const response = await updateTemplate({
        id: formData.value.id,
        ...submitData
      })
      if (response.success) {
        return { success: true, message: t('message.template.saveSuccess'), data: response.data };
      } else {
        return { success: false, message: (response?.msg || t('message.template.updateFailed')) };
      }
    } else {
      const response = await createTemplate(submitData)
      if (response.success) {
        if (response.data?.id) {
          formData.value.id = response.data.id
        }
        ElMessage.success(t('message.template.saveSuccess'))
        return { success: true, message: t('message.template.saveSuccess'), data: response.data };
      } else {
        ElMessage.error(response?.msg || t('message.template.saveFailed'))
        return { success: false, message: t('message.template.saveFailed') };
      }
    }
  } catch (error) {
    ElMessage.error(error.message || t('message.template.saveFailed'))
    return { success: false, message: error.message || t('message.template.saveFailed') };
  }
}

// ========== 从机相关方法 ==========
const createNewSlaveTab = () => {
  const tabIndex = slaveTabs.value.length + 1
  return {
    name: `slave${tabIndex}`,
    label: `${t('message.slave.tabName')} ${tabIndex}`,
    protocol: 1,
    variables: [],
    selectedVariables: []
  }
}

const saveSlave = async (tab) => {
  try {
    if (!tab.label || !tab.protocol) {
      ElMessage.error(t('message.slave.completeRequiredFields'))
      return { success: false, message: t('message.slave.completeRequiredFields') };
    }

    if (formData.value.id <= 0) {
      const rettempData = await createTemplateSumit();
      if (!rettempData.success) {
        return { success: false, message: t('message.template.saveFailed') };
      }
    }

    const submitData = {
      name: tab.label,
      protocol_id: tab.protocol,
      template_id: formData.value.id,
      company_id: formData.value.company_id
    }

    if (tab.id) {
      const response = await updateSlave({ id: tab.id, ...submitData })
      if (response.success) {
        return { success: true, message: t('message.slave.updateSuccess'), data: response.data };
      } else {
        return { success: true, message: (response?.msg || t('message.slave.updateFail')), data: response.data };
      }
    } else {
      const response = await createSlave(submitData)
      if (response.success) {
        tab.id = response.data.id
        ElMessage.success(t('message.slave.createSuccess'))
        return { success: true, message: t('message.slave.createSuccess'), data: response.data };
      } else {
        ElMessage.error(response?.msg || t('message.slave.createFail'))
        return { success: false, message: t('message.slave.createFail'), data: response.data };
      }
    }
  } catch (error) {
    ElMessage.error(t('message.common.error') + error.message)
    return { success: false, message: error.message };
  }
}

const saveAllSlaves = async () => {
  try {
    for (const tab of slaveTabs.value) {
      const ret = await saveSlave(tab)
      if (!ret.success)
        return ret
    }
    return { success: true, message: '' };
  } catch (error) {
    return { success: false, message: '' };
  }
}

const addTab = async (targetName, action) => {
  if (action === "add") {
    const lastTab = slaveTabs.value[slaveTabs.value.length - 1]

    if (!lastTab.label || !lastTab.protocol) {
      ElMessage.warning(t('message.slave.completeCurrentTab'))
      return
    }

    try {
      const retSlave = await saveSlave(lastTab)

      if (!retSlave.success) {
        return;
      }

      const newTab = createNewSlaveTab()
      slaveTabs.value.push(newTab)
      activeTab.value = newTab.name
      updateSlaveCount(slaveTabs.value.length)
    } catch (error) {
      ElMessage.error(t('message.common.saveFailed') + error.message)
    }
  }
}

const removeTab = async (targetName) => {
  if (slaveTabs.value.length <= 1) {
    ElMessage.warning(t('message.slave.keepOneTab'))
    return
  }

  try {
    await ElMessageBox.confirm(
      t('message.slave.confirmDeleteTab'),
      t('message.common.warning'),
      {
        confirmButtonText: t('message.common.confirm'),
        cancelButtonText: t('message.common.cancel'),
        type: 'warning'
      }
    )

    const tabToRemove = slaveTabs.value.find(tab => tab.name === targetName)

    if (tabToRemove?.id) {
      const submitDataUp = {
        id: tabToRemove.id,
        template_id: formData.value.id,
        company_id: formData.value.company_id
      }
      const response = await deleteSlave(submitDataUp);
      if (!response.success) {
        ElMessage.error(response?.msg || t('message.slave.deleteFailed'))
        return
      }
    }

    let newActiveTab = activeTab.value
    if (activeTab.value === targetName) {
      const currentIndex = slaveTabs.value.findIndex(tab => tab.name === targetName)
      newActiveTab = slaveTabs.value[currentIndex + 1]?.name ||
        slaveTabs.value[currentIndex - 1]?.name
    }

    slaveTabs.value = slaveTabs.value.filter(tab => tab.name !== targetName)

    if (activeTab.value === targetName) {
      activeTab.value = newActiveTab
    }

    loadVariables();
    updateSlaveCount(slaveTabs.value.length)

    ElMessage.success(t('message.slave.deleteSuccess'))
  } catch {
    // 用户取消删除
  }
}

const handleTabChange = (activeName) => {
  const tab = slaveTabs.value.find(t => t.name === activeName)
  if (!tab) return
  queryParams.pageNum = 1
  queryParams.pageSize = 5
  searchVariables()
}

const renderTabLabel = (tab) => {
  if (!tab) {
    return t('message.slave.defaultTabLabel');
  }
  const label = tab.label || t('message.slave.tabName');
  return `${label}`;
}

// ========== 变量相关方法 ==========
const converUpdateVariableData = (item) => {
  const ensureNumber = (value) => {
    if (value === null || value === undefined) return 0
    const num = Number(value)
    return isNaN(num) ? 0 : num
  }

  return {
    id: item.id,
    name: item.name,
    display_name: item.display_name,
    description: item.description,
    name_group: item.name_group,
    register_type: ensureNumber(item.register_type),
    address_one: ensureNumber(item.address_one),
    address_two: ensureNumber(item.address_two),
    address_three: ensureNumber(item.address_three),
    address_four: ensureNumber(item.address_four),
    address_five: ensureNumber(item.address_five),
    address_six: ensureNumber(item.address_six),
    address_decimal: ensureNumber(item.address_decimal),
    register_num: ensureNumber(item.register_num),
    data_type_id: ensureNumber(item.data_type_id),
    rw_type_id: ensureNumber(item.rw_type_id),
    storage_type_id: ensureNumber(item.storage_type_id),
    var_type_id: ensureNumber(item.var_type_id),
    slave_id: ensureNumber(item.slave_id),
    template_id: ensureNumber(item.template_id),
    unit: item.unit,
    mult: ensureNumber(item.mult),
    minimum: ensureNumber(item.minimum),
    maximum: ensureNumber(item.maximum),
    value: ensureNumber(item.value),
    company_id: ensureNumber(item.company_id)
  }
}

const converVariableData = (item) => {
  return {
    id: item.id,
    name: item.name,
    display_name: item.display_name,
    description: item.description,
    name_group: item.name_group,
    register: item.register_type.toString() + item.address_one.toString().padStart(4, '0'),
    register_type: item.register_type,
    address_one: item.address_one || 0,
    address_two: item.address_two || 0,
    address_three: item.address_three || 0,
    address_four: item.address_four || 0,
    address_five: item.address_five || 0,
    address_six: item.address_six || 0,
    address_decimal: item.address_decimal || 0,
    register_num: item.register_num || 1,
    data_type_id: item.data_type_id,
    data_type_name: findOptionName(valueTypeOptions, item.data_type_id),
    rw_type_id: item.rw_type_id,
    rw_type_name: findOptionName(rwTypeOptions.value, item.rw_type_id),
    storage_type_id: item.storage_type_id,
    storage_type_name: findOptionName(storageModeOptions.value, item.storage_type_id),
    var_type_id: item.var_type_id,
    var_type_name: findOptionName(varTypeOptions, item.var_type_id),
    slave_id: item.slave_id,
    template_id: item.template_id,
    unit: item.unit,
    mult: smartFixFloatPrecision(item.mult) ?? 1,
    minimum: smartFixFloatPrecision(item.minimum) ?? -999999,
    maximum: smartFixFloatPrecision(item.maximum) ?? 9999999,
    value: smartFixFloatPrecision(item.value) ?? 0,
    company_id: item.company_id
  }
}

const findOptionName = (options, id) => {
  if (!Array.isArray(options)) {
    if (options && options.value) {
      options = options.value;
    } else {
      return '';
    }
  }
  const found = options.find(item => item.value === id);
  return found ? found.label : '';
}

const processVariableData = (apiData) => {
  return apiData.map(item => converVariableData(item))
}

const addVariable = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName)
  if (!tab) return

  try {
    const retData = await saveSlave(tab)
    if (!retData.success) {
      return;
    }

    resetCurrentVariable(tab.id)

    variableDialogTitle.value = t('message.slave.addVariable')
    variableDialogVisible.value = true
  } catch (error) {
    ElMessage.success(t('message.slave.variableSaveFailed') + error)
  }
}

const editVariable = (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName)
  if (!tab) return

  const originalData = tab.variables[index]
  currentVariable.value = {
    id: originalData.id,
    name: originalData.name,
    display_name: originalData.display_name,
    description: originalData.description,
    name_group: originalData.name_group,
    register_type: originalData.register_type,
    address_one: originalData.address_one,
    address_two: originalData.address_two,
    address_three: originalData.address_three,
    address_four: originalData.address_four,
    address_five: originalData.address_five,
    address_six: originalData.address_six,
    address_decimal: originalData.address_decimal,
    register_num: originalData.register_num,
    data_type_id: originalData.data_type_id,
    rw_type_id: originalData.rw_type_id,
    storage_type_id: originalData.storage_type_id,
    var_type_id: originalData.var_type_id,
    timed_storage_frequency: originalData.timed_storage_frequency,
    change_storage_val: originalData.change_storage_val,
    interval: originalData.interval,
    var_flag: originalData.var_flag,
    unit: originalData.unit,
    mult: originalData.mult,
    minimum: originalData.minimum,
    maximum: originalData.maximum,
    value: originalData.value,
    slave_id: originalData.slave_id,
    template_id: originalData.template_id,
    company_id: originalData.company_id
  }

  variableDialogTitle.value = t('message.slave.editVariable')
  variableDialogVisible.value = true
}

const saveVariable = async () => {
  try {
    const tab = slaveTabs.value.find(t => t.name === activeTab.value)
    if (!tab) return

    if (currentVariable.value.name === '') {
      ElMessage.error(t('message.slave.variableInputName'))
      return
    }

    const existingIndex = tab.variables.findIndex(v => v.id === currentVariable.value.id)
    const submitData = converUpdateVariableData(currentVariable.value)
    submitData.slave_id = tab.id
    submitData.template_id = formData.value.id
    submitData.company_id = formData.value.company_id

    if (submitData.id > 0) {
      const response = await updateVariable(submitData)

      if (response.success) {
        tab.variables[existingIndex] = converVariableData(currentVariable.value)
        ElMessage.success(t('message.slave.variableUpdateSuccess'))
      } else {
        ElMessage.error(response?.msg || t('message.slave.variableUpdateFailed'))
      }
    } else {
      delete submitData.id
      const response = await createVariable(submitData)
      if (response.success) {
        ElMessage.success(t('message.common.addSuccess'))
      } else {
        ElMessage.error(`${response?.msg}`);
      }
    }
    await loadVariables()
    variableDialogVisible.value = false
  } catch (error) {
    ElMessage.error(t('message.slave.variableSaveFailed') + error.message)
  }
}

const deleteVariable = async (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName)
  if (!tab) return

  try {
    currentVariable.value = { ...tab.variables[index] }

    if (currentVariable.value.id > 0) {
      const deleteParm = {
        ids: [currentVariable.value.id],
        slave_id: currentVariable.value.slave_id,
        template_id: currentVariable.value.template_id,
        company_id: formData.value.company_id
      }
      const response = await deleteVariableById(deleteParm)

      if (response.success) {
        tab.variables.splice(index, 1)
        updateVarCount()
        ElMessage.success(t('message.slave.variableDeleted'))
      } else {
        ElMessage.success(response?.msg || t('message.slave.variableDeleteFailed'))
      }
    }
  } catch (error) {
    ElMessage.error(t('message.slave.variableDeleteFailed') + error.message)
  }
}

const batchDeleteVariables = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName)
  if (!tab || !tab.selectedVariables.length) return

  try {
    await ElMessageBox.confirm(
      t('message.slave.confirmDeleteVariables', { count: tab.selectedVariables.length }),
      t('message.common.warning'),
      {
        confirmButtonText: t('message.common.confirm'),
        cancelButtonText: t('message.common.cancel'),
        type: 'warning'
      }
    )

    const deleteParm = {
      ids: tab.selectedVariables.map(v => v.id),
      slave_id: tab.id,
      template_id: formData.value.id,
      company_id: formData.value.company_id
    }

    const response = await deleteVariableById(deleteParm)
    if (response.success) {
      tab.variables = tab.variables.filter(
        variable => !tab.selectedVariables.some(selected => selected.id === variable.id)
      )
      tab.selectedVariables = []
      updateVarCount()
      searchVariables();
      ElMessage.success(t('message.slave.variableDeleted'))
    } else {
      ElMessage.error(response.msg || t('message.slave.variableDeleteFailed'))
    }
  } catch {
    // 用户取消删除
  }
}

const handleSelectionChange = async (tabName, selection) => {
  const tab = slaveTabs.value.find(t => t.name === tabName)
  if (tab) {
    tab.selectedVariables = selection
  }
}

const searchVariables = async () => {
  try {
    queryParams.template_id = formData.value.id
    const currentTab = slaveTabs.value.find(tab => tab.name === activeTab.value)
    queryParams.slave_id = currentTab?.id || 0

    if (queryParams.slave_id <= 0)
      return;

    const { total, ...queryParamsWithoutTotal } = queryParams
    const response = await getVariablesByTemplate(queryParamsWithoutTotal, total)

    if (!response.success) {
      ElMessage.Error(response?.msg);
      return;
    }

    if (currentTab && response.success) {
      if (response.data?.list?.length > 0) {
        currentTab.variables = processVariableData(response.data.list)
      } else {
        resetCurrentVariable(queryParams.slave_id)
      }

      queryParams.total = response.data.totalCount || 0
      updateVarCount()
    }
  } catch (error) {
    ElMessage.error(error.message)
  }
}

const loadVariables = async () => {
  if (formData.value.id) {
    await searchVariables()
  }
}

// ========== 分页相关 ==========
const handleSizeChange = (val) => {
  queryParams.pageSize = val
  searchVariables()
}

const handleCurrentChange = (val) => {
  queryParams.pageNum = val
  searchVariables()
}

// ========== 导入相关方法 ==========
const importVariables = async (tabName) => {
  try {
    await formRef.value.validate();
  } catch (error) {
    ElMessage.error(error.message || t('message.template.validate'))
    return { success: false, message: t('message.template.validate') };
  }
  openImportDialog(tabName)
}

const openImportDialog = (tabName) => {
  currentTabName.value = tabName
  importDialogVisible.value = true
  resetImportForm()
}

const closeImportDialog = () => {
  importDialogVisible.value = false
  resetImportForm()
}

const resetImportForm = () => {
  selectedFile.value = null
  if (importFileDialog.value) {
    importFileDialog.value.clearFiles()
  }
  uploadKey.value++
}

const handleFileChange = (file) => {
  const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
  const isExcel = validTypes.includes(file.raw.type) ||
    file.raw.name.endsWith('.xlsx') ||
    file.raw.name.endsWith('.xls')

  if (!isExcel) {
    ElMessage.error(t('message.slave.onlyExcelAllowed'))
    return false
  }

  const isLt5M = file.raw.size / 1024 / 1024 < 5
  if (!isLt5M) {
    ElMessage.error(t('message.slave.fileTooLarge'))
    return false
  }

  selectedFile.value = file.raw
  return true
}

const confirmImport = async () => {
  if (!selectedFile.value) {
    ElMessage.warning(t('message.slave.selectFileFirst'))
    return
  }

  const tab = slaveTabs.value.find(t => t.name === currentTabName.value)
  if (!tab) {
    ElMessage.error(t('message.slave.tabNotFound'))
    return
  }

  if (!tab.id) {
    try {
      const retData = await saveSlave(tab)
      if (!retData.success) {
        return
      }
    } catch (error) {
      ElMessage.error(t('message.slave.saveSlaveFirst'))
      return
    }
  }

  if (!formData.value.id) {
    try {
      const retData = await createTemplateSumit()
      if (!retData.success) {
        return
      }
    } catch (error) {
      ElMessage.error(t('message.template.saveTemplateFirst'))
      return
    }
  }

  importLoading.value = true

  try {
    const formData1 = {
      file: selectedFile.value,
      slave_id: tab.id,
      template_id: formData.value.id,
      company_id: formData.value.company_id
    }

    const response = await importVariablesByFile(formData1)

    if (response.success) {
      ElMessage.success(t('message.slave.importSuccess'))
      closeImportDialog()
      await loadVariables()
    } else {
      ElMessage.error(response.msg || t('message.slave.importFailed'))
    }
  } catch (error) {
    console.error('Import error:', error)
    ElMessage.error(t('message.slave.importFailed') + (error.response?.data?.message || error.message))
  } finally {
    importLoading.value = false
  }
}

// ========== 导入更新相关方法（新增）==========
const importUpdateVariables = async (tabName) => {
  try {
    await formRef.value.validate();
  } catch (error) {
    ElMessage.error(error.message || t('message.template.validate'))
    return { success: false, message: t('message.template.validate') };
  }
  
  currentUpdateTabName.value = tabName
  importUpdateDialogVisible.value = true
  resetImportUpdateForm()
}

const closeImportUpdateDialog = () => {
  importUpdateDialogVisible.value = false
  resetImportUpdateForm()
}

const resetImportUpdateForm = () => {
  selectedUpdateFile.value = null
  if (importUpdateFileDialog.value) {
    importUpdateFileDialog.value.clearFiles()
  }
  importUpdateUploadKey.value++
}

const handleImportUpdateFileChange = (file) => {
  const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
  const isExcel = validTypes.includes(file.raw.type) ||
    file.raw.name.endsWith('.xlsx') ||
    file.raw.name.endsWith('.xls')

  if (!isExcel) {
    ElMessage.error(t('message.slave.onlyExcelAllowed'))
    return false
  }

  const isLt5M = file.raw.size / 1024 / 1024 < 5
  if (!isLt5M) {
    ElMessage.error(t('message.slave.fileTooLarge'))
    return false
  }

  selectedUpdateFile.value = file.raw
  return true
}

const confirmImportUpdate = async () => {
  if (!selectedUpdateFile.value) {
    ElMessage.warning(t('message.slave.selectFileFirst'))
    return
  }

  const tab = slaveTabs.value.find(t => t.name === currentUpdateTabName.value)
  if (!tab) {
    ElMessage.error(t('message.slave.tabNotFound'))
    return
  }

  if (!tab.id) {
    try {
      const retData = await saveSlave(tab)
      if (!retData.success) {
        return
      }
    } catch (error) {
      ElMessage.error(t('message.slave.saveSlaveFirst'))
      return
    }
  }

  if (!formData.value.id) {
    try {
      const retData = await createTemplateSumit()
      if (!retData.success) {
        return
      }
    } catch (error) {
      ElMessage.error(t('message.template.saveTemplateFirst'))
      return
    }
  }

  importUpdateLoading.value = true

  try {
    const formData1 = {
      file: selectedUpdateFile.value,
      slave_id: tab.id,
      template_id: formData.value.id,
      company_id: formData.value.company_id
    }

    const response = await importUpdateVariablesByFile(formData1)

    if (response.success) {
      ElMessage.success(t('message.slave.importUpdateSuccess') || 'Import update successful')
      closeImportUpdateDialog()
      await loadVariables()
    } else {
      ElMessage.error(response.msg || t('message.slave.importUpdateFailed') || 'Import update failed')
    }
  } catch (error) {
    console.error('Import update error:', error)
    ElMessage.error(t('message.slave.importUpdateFailed') + (error.response?.data?.message || error.message))
  } finally {
    importUpdateLoading.value = false
  }
}

// ========== 导出相关方法 ==========
const handleExport = async () => {
  try {
    await formRef.value.validate();
  } catch (error) {
    ElMessage.error(error.message || t('message.template.validate'))
    return { success: false, message: t('message.template.validate') };
  }

  try {
    exportLoading.value = true

    const currentTab = slaveTabs.value.find(tab => tab.name === activeTab.value)
    if (!currentTab) {
      ElMessage.error(t('message.slave.tabNotFound'))
      return
    }

    if (currentTab?.id <= 0)
      return;

    const params = {
      template_id: formData.value.id,
      slave_id: queryParams.slave_id,
      name: queryParams.name
    }

    exportLoading.value = true
    const response = await exportVariablesByFile(params)

    if (!(response.data instanceof Blob)) {
      ElMessage.error(t('message.slave.exportDataError'))
      return;
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url

    let fileName = `VariablesExport_${new Date().toISOString().slice(0, 100)}.xlsx`
    const contentDisposition = response.headers['content-disposition']

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/i)
      if (fileNameMatch && fileNameMatch.length > 1) {
        fileName = decodeURIComponent(fileNameMatch[1])
      }
    }

    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }, 100)

    ElMessage.success(t('message.slave.exportSuccess'))
  } catch (error) {
    console.error(t('message.slave.exportFailed'), error)

    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text()
        const errorData = JSON.parse(errorText)
        ElMessage.error(errorData.msg || errorData.message || t('message.slave.exportError'))
      } catch (e) {
        ElMessage.error(t('message.slave.exportError'))
      }
    } else {
      ElMessage.error(error.message || t('message.slave.exportError'))
    }
  } finally {
    exportLoading.value = false
  }
}

// ========== 公司树相关方法 ==========
const loadCompanyTree = async () => {
  if (companyLoaded.value) return

  try {
    companyLoading.value = true
    const res = await getCompanyTree(queryCompanyTreeParams)
    companyTreeData.value = buildTree(res.data.list || res.data)

    if (props.templateData?.company_id && !formData.value.company_id) {
      formData.value.company_id = props.templateData.company_id
      formData.value.company_name = findCompanyName(
        props.templateData.company_id,
        companyTreeData.value
      )
    }

    companyLoaded.value = true
  } catch (error) {
    ElMessage.error(error.message || 'Failed to load company tree')
  } finally {
    companyLoading.value = false
  }
}

const buildTree = (items) => {
  if (items.some(item => item.children)) return items

  const map = {}
  const roots = []

  items.forEach(item => {
    map[item.id] = { ...item, children: [] }
  })

  items.forEach(item => {
    if (item.parent_id && map[item.parent_id]) {
      map[item.parent_id].children.push(map[item.id])
    } else {
      roots.push(map[item.id])
    }
  })

  return roots
}

const findCompanyName = (id, tree) => {
  for (const node of tree) {
    if (node.id === id) return node.name
    if (node.children) {
      const found = findCompanyName(id, node.children)
      if (found) return found
    }
  }
  return ''
}

const handleTreeVisibleChange = (visible) => {
  if (visible && !companyLoaded.value) {
    loadCompanyTree()
  }
}

// ========== 其他方法 ==========
const changeGetType = (type) => {
  formData.value.get_type = parseInt(type, 10)
  formData.value.get_type_name = type === '1' ? 'Type A' : 'Type B'
}

const updateVarCount = () => {
  let total = 0
  slaveTabs.value.forEach(tab => {
    total += tab.variables.length
  })
  formData.value.var_total = total
}

const updateSlaveCount = (count) => {
  formData.value.device_total = count
}

const submitForm = async () => {
  const ret = await createTemplateSumit()
  if (ret.success) {
    const retS = await saveAllSlaves()
    if (retS.success) {
      cleanup()
    }
    return retS;
  } else {
    return ret;
  }
}

const cleanup = () => {
  initializeSlaveTabs()
  formData.value = {
    id: 0,
    name: '',
    company_id: null,
    company_name: '',
    get_type: 2,
    get_type_name: '',
    sub_user: 0,
    state_type: 1,
    var_total: 0,
    device_total: 0
  }
  Object.assign(queryParams, {
    template_id: null,
    slave_id: null,
    name: '',
    pageNum: 1,
    pageSize: 5,
    total: 0
  })
}

// ========== 生命周期 ==========
onMounted(async () => {
  try {
    initializeSlaveTabs();
    loadOptions();
    await loadVariables();
    await loadCompanyTree(queryCompanyTreeParams);

    tabsReady.value = true;

    const options = await fetchVariableOptions()
    variableOptions.value = options

    varTypeOptions.value = options.varTypes.list.map(item => ({
      value: item.id,
      label: item.name
    }))

    valueTypeOptions.value = options.dataTypes.list.map(item => ({
      value: item.id,
      label: item.name
    }))

    rwTypeOptions.value = options.rwTypes.list.map(item => ({
      value: item.id,
      label: item.name
    }))

    storageModeOptions.value = options.storageTypes.list.map(item => ({
      value: item.id,
      label: item.name
    }))

    protocolOptions.value = options.protocolTypes.list.map(item => ({
      value: item.id,
      label: item.name
    }))
  } catch (error) {
    ElMessage.error(error.message)
  }
})

watch(
  () => props.templateData,
  (val) => {
    if (val) {
      formData.value = { ...formData.value, ...val }
      if (val.company_id) {
        formData.value.company_name = findCompanyName(
          val.company_id,
          companyTreeData.value
        )
      }
    }
  },
  { immediate: true, deep: true }
)

watch(() => props.slaveTabsData, (newVal) => {
  if (newVal?.length > 0) {
    initializeSlaveTabs();
    loadVariables()
    tabsReady.value = true;
  }
}, { immediate: true, deep: true });

// 暴露方法给父组件
defineExpose({
  submitForm,
  cleanup,
})
</script>

<style scoped>
/* 确保表格只读样式 */
.el-table .cell {
  user-select: text;
  cursor: default;
}

.button-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.getType-switch {
  display: flex;
  gap: 10px;
}

.save-button-col {
  display: flex;
  justify-content: flex-end;
}

.getType-switch .el-button,
.save-button {
  font-size: 14px;
  padding: 9px 15px;
}

.slave-tabs {
  margin-top: 20px;
}

.slave-config {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.action-buttons {
  margin: 15px 0;
}

.button-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.search-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.add-tab-btn {
  margin-left: 10px;
}

:deep(.el-tabs.is-disabled) {
  opacity: 0.6;
  pointer-events: none;
}

:deep(.el-tabs__header) {
  display: flex;
  align-items: center;
}

:deep(.el-tabs__nav-wrap) {
  flex: 1;
}

:deep(.el-tabs__item) {
  display: flex;
  align-items: center;
}

:deep(.el-tabs__item .el-icon-close) {
  margin-top: 1px;
}

.getType-switch .el-button {
  margin-right: 10px;
}

.getType-switch .el-button.active {
  background-color: #409eff;
  color: white;
  border-color: #409eff;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .button-row {
    flex-direction: column;
    gap: 10px;
  }

  .save-button-col {
    justify-content: flex-start;
    width: 100%;
  }

  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .button-group,
  .search-group {
    width: 100%;
    justify-content: flex-start;
  }

  .search-group {
    flex-wrap: wrap;
  }
}

.empty-value {
  color: #999;
  font-style: italic;
}

.import-dialog-content {
  padding: 20px;
}

.selected-file {
  margin-top: 8px;
  padding: 4px 8px;
  background-color: #f0f9eb;
  border-radius: 4px;
  color: #67c23a;
}

.import-update-tip {
  margin-top: 8px;
}
</style>